import React from 'react';
import {
  Button, Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import {WithTranslation, withTranslation} from 'react-i18next';

interface JsonModalProps extends WithTranslation {
  toggle: () => void;
  isOpen: boolean;
  content: string;
  onClose: () => void;
  title: string;
}

class JsonModal extends React.PureComponent<JsonModalProps> {

  render() {
      const { t } = this.props;

    return (
      <Modal style={{ minWidth: '1060px'}} isOpen={this.props.isOpen} toggle={this.props.toggle} autoFocus={false}>
        <ModalHeader toggle={this.props.toggle}>{this.props.title}</ModalHeader>
        <div>
          <ModalBody>
            <div>
              <div className="scrolling-modal-div-large">
                <pre>{JSON.stringify(this.props.content, null, 2)}</pre>
              </div>
            </div>
          </ModalBody>
        </div>
        <ModalFooter>
          <Button color="primary" onClick={this.props.onClose}>{t('b.close').toUpperCase()}</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default withTranslation()(JsonModal);
